import React from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FAQS } from "@/lib/brand";

export default function FAQ() {
  return (
    <section data-testid="faq-section" id="faq" className="py-16 md:py-24 bg-bone">
      <div className="container-x grid grid-cols-12 gap-10">
        <div className="col-span-12 lg:col-span-5">
          <h2 className="text-[32px] md:text-[44px] font-extrabold text-navy">Common questions</h2>
          <p className="mt-3 text-ink/85 max-w-md">Prefer to talk it through? Call 7483985244 or WhatsApp — we usually reply within minutes.</p>
        </div>
        <div className="col-span-12 lg:col-span-7">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-${i}`} className="border-b border-navy/15 py-1">
                <AccordionTrigger className="text-left text-navy font-bold text-[17px] md:text-[18px] hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-ink/80 leading-relaxed text-[15.5px] pt-2 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
